[
    {
        "author": "morganjphillips",
        "date": "Dec 19, 2023",
        "text": "Just the most amazing app. Did exactly what we wanted it too, with incredible quality."
    },
    {
        "author": "Meana Anderson",
        "date": "Nov 21, 2023",
        "text": "I absolutely loved having this live stream service for my wedding. It was clear and my guests enjoyed watching our ceremony from afar."
    },
    {
        "author": "MulhallBlair",
        "date": "Aug 1, 2023",
        "text": "Stellar app, easy to use, very intuitive. I would highly recommend it, less complicated than Facebook and youtube especially from the viewer’s perspective (single click and you are there). Worth every penny, one has enough to worry about without the stress of overly complicated streaming apps."
    },
    {
        "author": "meetaahlawat",
        "date": "Jun 28, 2023",
        "text": "By far the easiest to use. I could live stream my event with such ease! And it recorded it and it let the guests leave messages."
    },
    {
        "author": "Cristina & Mehdi",
        "date": "Mar 21, 2023",
        "text": "Easy to use, not crazy expensive, great connection and image. Our family and friends loved it!"
    },
    {
        "author": "TheKozo",
        "date": "Feb 27, 2023",
        "text": "Great affordable easy to use option for streaming an event."
    },
    {
        "author": "Michelle81110",
        "date": "Jan 24, 2023",
        "text": "The platform was exactly what we were looking for. It’s easy to use & very affordable. I love that it does not limit the number of viewers that can join in."
    },
    {
        "author": "kd4538",
        "date": "Oct 24, 2022",
        "text": "This was so easy to use and share. I looked at so many other platforms and they were so complicated. None of our guests had any issue. Highly recommend!!"
    },
    {
        "author": "Mackp19",
        "date": "Jul 30, 2022",
        "text": "This app is so easy to use. I’m a 74 year old curmudgeon and I can use it. Plus when I screw up their support helps me fix it. Really I am so happy I was introduced to it."
    },
    {
        "author": "CURRAN & JESSICA SAY \"I Do!\"",
        "date": "Jun 29, 2022",
        "text": "This was the best decision we made! The ability to livestream for family and friends that could not attend was invaluable!!"
    },
    {
        "author": "2Beware!!",
        "date": "May 19, 2022",
        "text": "If I could give this app ten stars I would!"
    },
    {
        "author": "bharathb9",
        "date": "Jan 7, 2022",
        "text": "Extremely delighted with the service. This is a no nonsense app. You get to test and then you purchase and off you go!"
    },
    {
        "author": "SAE BODY",
        "date": "Dec 7, 2021",
        "text": "EventLive exceeded our expectations! So if you are thinking about using them JUST DO IT!!! The video and sound quality was excellent!"
    }
]